import { render, staticRenderFns } from "./0GeneralInfo.vue?vue&type=template&id=5da69a26"
import script from "./0GeneralInfo.vue?vue&type=script&lang=js"
export * from "./0GeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports